import { Form, Row } from 'antd';
import classNames from 'classnames/bind';
import { useEffect, useState } from 'react';
import OtpInput from 'react-otp-input';
import styles from './FormOTP.module.scss';

const cx = classNames.bind(styles);

const OTPModal = ({ formOTP, onFinishOTP, otp, onChangeOtp, errOtp, numPhone, sendOTPToPhone }) => {
    const [timeLeft, setTimeLeft] = useState(60);

    const handleReSendOTP = () => {
        if (timeLeft === 0) {
            sendOTPToPhone(numPhone);
            setTimeLeft(60);
        }
    };

    useEffect(() => {
        if (!timeLeft) {
            window.confirmationResult = '';
            return;
        }

        const intervalId = setTimeout(() => {
            setTimeLeft(timeLeft - 1);
        }, 1000);

        return () => clearTimeout(intervalId);
    }, [timeLeft]);

    return (
        <>
            <Form onFinish={onFinishOTP} form={formOTP}>
                <Form.Item>
                    <Row justify="center" className={cx('name_page')}>
                        Enter OTP code
                    </Row>
                </Form.Item>
                <Form.Item>
                    <Row justify="center" className={cx('bio')}>
                        Confirmation code (6 digits) sent to phone number <span> {numPhone}</span>
                    </Row>
                </Form.Item>
                <Form.Item name="otp" style={{ marginTop: '30px' }}>
                    <Row justify="center">
                        <OtpInput
                            name="otp"
                            value={otp}
                            shouldAutoFocus={true}
                            onChange={onChangeOtp}
                            numInputs={6}
                            className={cx('otp_login')}
                            isInputNum={true}
                        />
                    </Row>
                    <Row className={cx('err')}>{errOtp}</Row>
                </Form.Item>
                <Form.Item style={{ marginTop: '40px' }}>
                    <button
                        disabled={timeLeft === 0}
                        type="submit"
                        className={cx('btn_login', timeLeft === 0 && 'btn_disabled')}
                    >
                        Confirm
                    </button>
                    {timeLeft === 0 && <Row className={cx('err')}>The OTP code has expired, please resend it</Row>}
                </Form.Item>
                <Row justify="center" className={cx('sign_in')}>
                    <p> Didn't receive the code?</p>
                    <span className={cx('re_sendOTP', timeLeft !== 0 && 'disabled')} onClick={handleReSendOTP}>
                        Resend {timeLeft !== 0 && `(${timeLeft}s)`}
                    </span>
                </Row>
            </Form>
        </>
    );
};

export default OTPModal;
